import { useLogin } from '@refinedev/core';
import { useState } from 'react';

import { enviarCodigo } from '../authProvider';

/**
 * Entrada do painel em dois passos: e-mail, depois o código de 6 dígitos que chega por e-mail.
 *
 * Mesmas regras de texto de `docs/04`: o erro diz o que fazer e aparece ao lado do campo.
 */
export function Login() {
  const { mutate: login, isPending: conferindo } = useLogin<{ email: string; code: string }>();
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  async function pedirCodigo(e: React.FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);

    const { erro: falha } = await enviarCodigo(email);
    setEnviando(false);

    if (falha) setErro(falha);
    else setEnviado(true);
  }

  function conferirCodigo(e: React.FormEvent) {
    e.preventDefault();
    setErro(null);
    login({ email, code }, { onSuccess: (r) => r?.error && setErro(r.error.message) });
  }

  return (
    <main style={estilos.tela}>
      <h1 style={estilos.marca}>
        venove
        <span style={estilos.ponto} /> <small style={estilos.sub}>painel</small>
      </h1>

      <form onSubmit={enviado ? conferirCodigo : pedirCodigo} style={estilos.form}>
        <label style={estilos.rotulo} htmlFor="email">
          E-mail da conta administradora
        </label>
        <input
          id="email"
          type="email"
          required
          autoComplete="email"
          value={email}
          disabled={enviado}
          onChange={(e) => setEmail(e.target.value)}
          style={estilos.campo}
        />

        {enviado && (
          <>
            <label style={estilos.rotulo} htmlFor="code">
              Código de 6 números
            </label>
            <input
              id="code"
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength={6}
              required
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              style={{ ...estilos.campo, letterSpacing: '0.3em', textAlign: 'center' }}
            />
          </>
        )}

        {erro && <p style={estilos.erro}>{erro}</p>}

        <button type="submit" disabled={enviando || conferindo} style={estilos.botao}>
          {enviado ? 'Entrar' : 'Enviar código'}
        </button>
      </form>
    </main>
  );
}

const estilos = {
  tela: {
    minHeight: '100%',
    display: 'grid',
    placeContent: 'center',
    gap: 24,
    padding: 24,
  },
  marca: { fontWeight: 800, letterSpacing: '-0.04em', fontSize: 32, margin: 0 },
  ponto: {
    display: 'inline-block',
    width: '0.22em',
    height: '0.22em',
    borderRadius: '50%',
    background: '#ff2e63',
    marginLeft: '0.04em',
  },
  sub: { fontWeight: 400, fontSize: 14, color: 'rgba(255,255,255,.62)' },
  form: { display: 'grid', gap: 8, width: 'min(360px, 90vw)' },
  rotulo: { fontSize: 13, color: 'rgba(255,255,255,.62)' },
  campo: {
    height: 48,
    borderRadius: 12,
    border: '1px solid rgba(255,255,255,.18)',
    background: '#1c1c1f',
    color: '#fff',
    padding: '0 12px',
    fontSize: 15,
  },
  erro: { color: '#ff6b6b', fontSize: 13, margin: 0 },
  botao: {
    height: 48,
    borderRadius: 12,
    border: 0,
    background: '#ff2e63',
    color: '#fff',
    fontWeight: 700,
    fontSize: 15,
    cursor: 'pointer',
    marginTop: 8,
  },
} satisfies Record<string, React.CSSProperties>;
